import React, { useState, useEffect } from "react";
import { Store } from "./Utility/Store";
import guide from "./Utility/actions";
import Select from "react-select";
import { components } from "react-select";
import Modal from "react-bootstrap/Modal";
import Button from "react-bootstrap/Button";
import { handleFundingOrgsHelper } from "./Utility/Helpers/handleFundingOrgs";
import { handleActivityCodeHelper } from "./Utility/Helpers/handleActivityCode";
import { handleInstrumentHelper } from "./Utility/Helpers/handleInstrument";
import { handleMentoredHelper } from "./Utility/Helpers/handleMentored";
import { handleReferenceLettersHelper } from "./Utility/Helpers/handleReferenceLetters";
import { handlePDPIHelper } from "./Utility/Helpers/handlePDPICode";
import { handleCareerStageHelper } from "./Utility/Helpers/handleCareerStage";
import { handleFundingCategoryHelper } from "./Utility/Helpers/handleFundingCategory";
import { handleFundingSubCategory_Helper } from "./Utility/Helpers/handleFundingSubCategory";
import { handleAppTypeHelper } from "./Utility/Helpers/handleAppType";
import { handleResearchInitiativeHelper } from "./Utility/Helpers/handleResearchInitiative";
import {
  formatDate,
  clinicalTrialAllowedOptions,
  updateDataQueryHelper,
  commonAC,
} from "./Utility/Helpers/sitewide";

import MobileDataView from "./View/MobileDataView";
import TableDataView from "./View/TableDataView";
import DetailedDataView from "./View/DetailedDataView";
import MoreFiltersView from "./View/MoreFiltersView";
import ReactPaginate from "react-paginate";
import { ReactComponent as Filter } from "bootstrap-icons/icons/filter.svg";
import { ReactComponent as TableIcon } from "bootstrap-icons/icons/table.svg";
import { ReactComponent as ListIcon } from "bootstrap-icons/icons/list-columns-reverse.svg";
import { ReactComponent as ExcelIcon } from "bootstrap-icons/icons/file-earmark-excel-fill.svg";
import { ReactComponent as ShareIcon } from "bootstrap-icons/icons/share-fill.svg";
import { ReactComponent as SaveIcon } from "bootstrap-icons/icons/bookmark-check-fill.svg";
import { ReactComponent as SearchIcon } from "bootstrap-icons/icons/search.svg";
import { ReactComponent as CopyIcon } from "bootstrap-icons/icons/clipboard-fill.svg";
import InformationToolTip from "./Utility/Helpers/InformationToolTip";
import {
  parse,
  startOfWeek,
  endOfWeek,
  startOfMonth,
  addMonths,
  endOfMonth,
  isValid,
} from "date-fns";
import SubCategoryFilters from "./View/SubCategoryFilters";
import NoResultView from "./View/NoResultView";
import CurrentFiltersPills from "./View/CurrentFiltersPills";
import RootLocation from "./Utility/root_location";
import GuideAPI from "./Utility/guide_api";
import axios from "axios";
import AnalyticsAPI from "./Utility/analytics_api";
import { Parser } from "html-to-react";
import "react-datepicker/dist/react-datepicker.css";

function useDebounce(value, delay) {
  const [debouncedValue, setDebouncedValue] = useState(value);

  useEffect(() => {
    const handler = setTimeout(() => {
      setDebouncedValue(value);
    }, delay);

    return () => {
      clearTimeout(handler);
    };
  }, [value, delay]);

  return debouncedValue;
}

function Main() {
  const { state, dispatch } = React.useContext(Store);
  const [query, setQuery] = useState("");
  const debouncedInputValue = useDebounce(query, 500);
  const [show, setShow] = useState(false);
  const handleClose = () => setShow(false);
  const handleShow = () => {
    recordAction("Advance Search", "Show");
    setShow(true);
  };
  const [activityCode, setActivityCode] = useState("");
  const [clinicalTrialOptions, setClinicalTrialOptions] = useState(false);
  const [fundingOrgs, setFundingOrgs] = useState([]);
  const [clinicalTrialAllowOptions, setClinicalTrialAllowOptions] = useState(
    [],
  );
  const [dataView, setDataView] = useState("table");
  const [type, setType] = useState(["notices"]);

  const [activeFOA, setActiveFOA] = useState(false);
  const [expiredFOA, setExpiredFOA] = useState(false);
  const [activeNotices, setActiveNotices] = useState(true);
  const [expiredNotices, setExpiredNotices] = useState(false);

  const [tabType, setTabType] = useState("notices");
  const [itemOffset, setItemOffset] = useState(0);
  const itemsPerPage = 20;
  const [pageCount, setPageCount] = useState(1);

  const [fundingCategory, setFundingCategory] = useState([]);
  const [noticeType, setNoticeType] = useState([]);
  const [fundingSubCategory_RTCD, setFundingSubCategory_RTCD] = useState([]);
  const [fundingSubCategory_RD, setFundingSubCategory_RD] = useState([]);
  const [fundingSubCategory_SB, setFundingSubCategory_SB] = useState([]);

  const [fundingOrganizations, setFundingOrganizations] = useState([]);
  const [activityCodesSelected, setActivityCodesSelected] = useState([]);
  const [clinicalTrialsSelected, setClinicalTrialsSelected] = useState("");
  const [clinicalTrialsAllowedSelected, setClinicalTrialsAllowedSelected] =
    useState("");
  const [fundingOpportunitySelected, setfundingOpportunitySelected] =
    useState("");
  const [fundingInstrumentSelected, setfundingInstrumentSelected] =
    useState("");
  const [issuingOrgSelected, setIssuingOrgSelected] = useState(false);
  const [appTypesSelected, setAppTypesSelected] = useState("");
  const [researchInitiativeSelected, setResearchInitiativeSelected] = useState("");
  const [careerStageSelected, setCareerStageSelected] = useState("");
  const [pdpiSelected, setpdpiSelected] = useState("");
  const [mentoredSelected, setMentoredSelected] = useState("");
  const [refLetterSelected, setRefLetterSelected] = useState("");
  const [showShareResults, setShowShareResults] = useState(false);
  const [saveResults, setSaveResults] = useState(false);
  const [linkCopied, setLinkCopied] = useState("");
  const [saveResult, setSaveResult] = useState({
    subscription: "",
    email: "",
    frequency: "daily",
  });
  const [saveResultError, setSaveResultError] = useState(false);
  const [noResult, setNoResult] = useState(false);
  const [isSmallScreen, setIsSmallScreen] = useState(false);
  const [queryParams, setQueryParams] = useState({});
  const [fundingSubRTCDShow, setFundingSubRTCDShow] = useState(false);
  const [fundingSubRDShow, setFundingSubRDShow] = useState(false);
  const [fundingSubSBShow, setFundingSubSBShow] = useState(false);
  const [titleSelected, setTitleSelected] = useState(false);
  const [InformationToolTipOptions, setInformationToolTipOptions] = useState(
    {},
  );
  const [career_stage, setCareer_stage] = useState([]);
  const [noticeSubject, setNoticeSubject] = useState([]);
  const [appTypesAllowed, setAppTypesAllowed] = useState([]);
  const [researchInitiative, setResearchInitiative] = useState([]);
  const [fundingOpportunityType, setFundingOpportunityType] = useState([]);
  const [orgsNames, setOrgsNames] = useState([]);
  const [alert, setAlert] = useState(false);
  const [emailAlert, setEmailAlert] = useState(false);
  const [session, recordSession] = useState({
    id: "",
    actions: [],
  });
  const [nosisCheckbox, setNosisCheckbox] = useState(true);

  const [startDate, setStartDate] = useState(new Date(1991, 0, 1));
  const [endDate, setEndDate] = useState(new Date());
  const date_utc_options = {
    year: "numeric",
    month: "long",
    day: "numeric",
    timeZone: "UTC",
  };
  const [exportLoading, setExportLoading] = useState(false);

  useEffect(() => {
    const handleBeforeUnload = () => {
      sessionStorage.removeItem("guidesearch_session");
    };

    if (!sessionStorage.getItem("guidesearch_session")) {
      let sessionID = generateSessionId();
      sessionStorage.setItem("guidesearch_session", sessionID);
    }

    recordSession({
      id: sessionStorage.getItem("guidesearch_session"),
      actions: [],
    });

    window.addEventListener("beforeunload", handleBeforeUnload);

    return () => {
      window.removeEventListener("beforeunload", handleBeforeUnload);
    };
  }, []);

  let generateSessionId = () => {
    const randomPart = Math.random().toString(36).slice(2, 9);
    const saltPart = Math.random().toString(36).slice(2, 9);
    const endPart = Math.random().toString(36).slice(2, 9);
    const timestampPart = Date.now();
    return `${timestampPart}-${randomPart}-${saltPart}-${endPart}`;
  };

  let flattenedArrays = (array) => {
    let temp = [];
    array.forEach((item) => {
      temp.push(item.label);
    });
    return temp;
  };

  let recordAction = (type, values) => {
    let temp_session = { ...session };
    if (typeof values === "object") {
      values = flattenedArrays(values);
    }

    if (typeof values === "boolean") {
      values = values.toString();
    }

    temp_session.actions.push({
      action_type: type,
      action: values,
      timestamp: Date.now(),
    });

    if (window.location.hostname !== "localhost") {
      axios.post(AnalyticsAPI, temp_session);
      recordSession(temp_session);
    }
  };

  let getSearchParams = () => {
    const hash = window.location.hash;
    const params = {};
    if (window.location.search !== "") {
      let searchParams = new URLSearchParams(window.location.search);
      searchParams.forEach((value, key) => {
        params[key] = value;
      });
    } else {
      if (hash !== "" && hash !== "#/") {
        if (getCookie("grants_legacy_url_alert") !== "hide") {
          setAlert(true);
        }

        const hashIndex = hash.indexOf("?");
        if (hashIndex !== -1) {
          const hashParamsString = hash.slice(hashIndex + 1);
          let searchParams = new URLSearchParams(hashParamsString);
          searchParams.forEach((value, key) => {
            params[key] = value;
          });
        }
      }
    }
    return params;
  };

  useEffect(() => {
    async function fetchOptions() {
      const o_response = await fetch(RootLocation + "/options/Orgs.json");
      const orgsName = await o_response.json();
      setOrgsNames(orgsName);

      const i_response = await fetch(
        RootLocation + "/options/InformationToolTipOptions.json",
      );
      const infoTips = await i_response.json();
      setInformationToolTipOptions(infoTips);

      const c_response = await fetch(
        RootLocation + "/options/CareerStage.json",
      );
      const caeerSt = await c_response.json();
      setCareer_stage(caeerSt);

      const f_response = await fetch(
        RootLocation + "/options/FundingOpportunityType.json",
      );
      const fundingOp = await f_response.json();
      setFundingOpportunityType(fundingOp);

      const n_response = await fetch(
        RootLocation + "/options/NoticeSubject.json",
      );
      const noticeSub = await n_response.json();
      setNoticeSubject(noticeSub);

      const a_response = await fetch(
        RootLocation + "/options/AppTypesAllowed.json",
      );
      const appTyp = await a_response.json();
      setAppTypesAllowed(appTyp);

      const r_response = await fetch(
        RootLocation + "/options/ResearchInitiative.json",
      );
      const researchInitiative = await r_response.json();
      setResearchInitiative(researchInitiative);

    }
    fetchOptions();
  }, []);

  const SORT_ORDER = [
    "notices",
    "active",
    "activenosis",
    "expired",
    "expirednosis",
  ];

  let sortParamType = (input) => {
    const wordsArray = input.split(",");
    wordsArray.sort((a, b) => SORT_ORDER.indexOf(a) - SORT_ORDER.indexOf(b));
    return wordsArray.join(",");
  };

  useEffect(() => {
    let params = getSearchParams();
    setQueryParams(params);

    let query_from_params = "";

    if (
      params.query &&
      params.query.trim() !== "" &&
      params.query !== "empty"
    ) {
      query_from_params = decodeURIComponent(params.query);
    }

    let start_date = "01011991";
    let end_date = formatDate(new Date());
    let pre_date = "";
    if (params.date) {
      start_date = params.date.split("-")[0];
      pre_date = start_date + "-" + end_date;
    } else {
      pre_date = start_date + "-" + formatDate(new Date());
    }

    let updateQuery = {
      perpage: 20,
      from: 0,
      sort: params.sort || "reldate:desc",
      type:
        (params.type && params.type === "active,notices,activenosis"
          ? "active,activenosis"
          : params.type) || "notices",
      parentic: params.parent_orgs || "all",
      primaryic: params.orgs || "all",
      activitycodes: params.ac || "all",
      doctype: params.foa || "all",
      daterange: pre_date,
      clinicaltrials: params.ct || "all",
      fields: params.fields || "all",
      apptype: params.apptype || "all",
      researchInitiative: params.researchInitiative || "all",
      noticeSubject: params.noticeSubject || "all",
      parentfoa: params.pfoa || "all",
      spons: params.spons || true,
      query: query_from_params,
    };

    guide.Result(dispatch, updateQuery);
    guide.Aggs(dispatch, updateQuery);
    guide.DefaultAggs(dispatch);
    guide.SetFundingCategory(dispatch);
    guide.SetFundingSubCategory(dispatch);
    guide.SetFundingInstrument(dispatch);
    guide.SetPDPI(dispatch);
    guide.SetCareerStage(dispatch);
    guide.SetMentored(dispatch);
    guide.SetActivityCodes(dispatch);
    guide.SetReferenceLetters(dispatch);
    guide.SetFilters(dispatch, updateQuery);

    if (Object.keys(params).length > 0) {
      setQuery(query_from_params);

      if (params.type && params.type !== "") {
        let temp_activeFOA = false;
        let temp_expiredFOA = false;
        let temp_activeNotices = false;
        let temp_expiredNotices = false;
        let temp_type = [];
        let temp_param_type = params.type;

        if (temp_param_type === "active,expired,activenosis,expirednosis") {
          temp_param_type = "active,activenosis,expired,expirednosis";
        }
        if (
          temp_param_type === "active,notices,activenosis" ||
          temp_param_type === "active,notices"
        ) {
          temp_param_type = "active,activenosis,notices";
        }

        temp_param_type = sortParamType(temp_param_type);

        if (temp_param_type.includes("active,activenosis")) {
          // temp_type.push("active");
          // temp_type.push("activenosis");
          // setNosisCheckbox(true);
          // temp_activeFOA = true;
          setTabType("foa");
        }

        if (temp_param_type === "active") {
          // temp_type.push("active");
          // temp_activeFOA = true;
          // setNosisCheckbox(false);
          setTabType("foa");
        }

        if (temp_param_type.includes("expired,expirednosis")) {
          // temp_type.push("expired");
          // temp_type.push("expirednosis");
          // temp_expiredFOA = true;
          setTabType("foa");
        }

        if (temp_param_type === "expired") {
          // temp_type.push("expired");
          // temp_expiredFOA = true;
          // setNosisCheckbox(false);
          setTabType("foa");
        }

        if (temp_param_type.includes("notices,activenosis")) {
          temp_type.push("notices");
          temp_type.push("activenosis");
          temp_activeNotices = true;
          setTabType("notices");
          setNosisCheckbox(true);
        }

        if (temp_param_type === "notices") {
          temp_type.push("notices");
          setNosisCheckbox(false);
          temp_activeNotices = true;
          setTabType("notices");
        }

        if (
          temp_param_type === "expired,active" ||
          temp_param_type === "active,expired"
        ) {
          // temp_type.push("expired");
          // temp_type.push("active");
          // temp_activeFOA = true;
          // temp_expiredFOA = true;
          setNosisCheckbox(false);
          setTabType("foa");
        }
        if (temp_param_type === "notices,expirednosis") {
          setTabType("notices");
          temp_type.push("notices");
          temp_type.push("expirednosis");
          temp_expiredNotices = true;
          temp_activeNotices = true;
          setNosisCheckbox(false);
        }

        if (
          temp_param_type.includes("expirednosis") &&
          !temp_param_type.includes("expired,expirednosis") &&
          !temp_param_type.includes("notices,expirednosis")
        ) {
          setTabType("notices");
          temp_expiredNotices = true;
          temp_type.push("expirednosis");
        }
        if (temp_param_type.includes("notices,activenosis,expirednosis")) {
          temp_type.push("notices");
          temp_type.push("activenosis");
          temp_activeNotices = true;
          setTabType("notices");
        }

        // active funding foas -- active,notices,activenosis

        setType(temp_type);
        setActiveFOA(temp_activeFOA);
        setExpiredFOA(temp_expiredFOA);
        setActiveNotices(temp_activeNotices);
        setExpiredNotices(temp_expiredNotices);
      }

      let selected_foas = [];
      if (params.foa && params.foa !== "all") {
        let foas = params.foa.split(",");
        foas.forEach((item) => {
          let obj = { value: "", label: "" };
          switch (item) {
            case "PA":
              obj.value = "PA";
              obj.label = "Program Announcement (PA)";
              break;
            case "PAS":
              obj.value = "PAS";
              obj.label = "PA with set-aside funds (PAS)";
              break;
            case "PAR":
              obj.value = "PAR";
              obj.label =
                "PA with special receipt, referral, and/or review considerations (PAR)";
              break;
            case "RFA":
              obj.value = "RFA";
              obj.label = "Request for Applications (RFA)";
              break;
            case "NOSIS":
              obj.value = "NOSIS";
              obj.label = "Notice of Special Interest (NOSI)";
              break;
            default:
              break;
          }
          selected_foas.push(obj);
        });
      }
      if (params.pfoa && params.pfoa === "yes") {
        selected_foas.push({
          value: "parentfoa",
          label: "Parent Announcement",
        });
      }
      if (selected_foas.length > 0) {
        setfundingOpportunitySelected(selected_foas);
      }

      if (
        params.noticeSubject &&
        params.noticeSubject !== "" &&
        params.noticeSubject !== "all"
      ) {
        let noticeSubject_p = params.noticeSubject.split(",");
        let selected_noticeSubject = [];
        noticeSubject_p.forEach((item) => {
          selected_noticeSubject.push({
            value: item,
            label: item,
          });
        });
        setTabType("notices");
        setNoticeType(selected_noticeSubject);
      }


      if (
        params.researchInitiative &&
        params.researchInitiative !== "" &&
        params.researchInitiative !== "all"
      ) {
        let researchInitiative_p = params.researchInitiative.split(",");
        let selected_researchInitiative = [];
        researchInitiative_p.forEach((item) => {
          selected_researchInitiative.push({
            value: item,
            label: item,
          });
        });
        setResearchInitiativeSelected(selected_researchInitiative);
      }

      if (params.spons && params.spons !== "") {
        if (params.spons === "true") {
          setIssuingOrgSelected(false);
        }
        if (params.spons === "false") {
          setIssuingOrgSelected(true);
        }
      }

      if (params.ac && params.ac !== "all") {
        let all_codes = params.ac.split(",");
        let selected_acs = [];
        all_codes.forEach((item) => {
          selected_acs.push({
            value: item.toUpperCase(),
            label: item.toUpperCase(),
          });
        });
        setActivityCodesSelected(selected_acs);
        guide.SetCustomAC(dispatch, {
          activity_code: all_codes,
        });
      }

      if (params.ct && params.ct !== "all") {
        if (params.ct.includes("not_allowed")) {
          setClinicalTrialsAllowedSelected("not_allowed");
        } else {
          setClinicalTrialOptions(true);
          setClinicalTrialsAllowedSelected("allowed");
          setClinicalTrialsSelected(params.ct);
        }
      }

      if (params.fields && params.fields !== "all") {
        if (params.fields === "title") {
          setTitleSelected(true);
        }
      }

      if (params.date) {
        const formatString = "MMddyyyy";
        const start = parse(
          params.date.split("-")[0],
          formatString,
          new Date(),
        );
        const end = new Date();
        setStartDate(start);
        setEndDate(end);
      }
    }

    // eslint-disable-next-line
  }, []);

  useEffect(() => {
    setPageCount(state.total_result / itemsPerPage);
  }, [state.total_result]);

  useEffect(() => {
    if (state.result.length !== 0 && state.total_result === 0) {
      let updateDataQuery = updateDataQueryHelper(state, []);
      recordAction("No Result", analyticsUrl(updateDataQuery));
    }

    if (
      state.result.data &&
      state.result.data.hits.hits &&
      state.result.data.hits.hits.length > 0
    ) {
      setNoResult(false);
    }

    // eslint-disable-next-line
  }, [state.result]);

  useEffect(() => {
    if (
      state.default_orgs &&
      state.default_orgs.parent &&
      orgsNames.length > 0
    ) {
      let org_list = state.default_orgs.parent.buckets;

      // common fund manual inject
      const nihObject = org_list.find((item) => item.key === "NIH");

      if (nihObject) {
        // Remove RMOD, OSC, and Roadmap from the buckets array
        nihObject.child.buckets = nihObject.child.buckets.filter(
          (bucket) => !["RMOD", "OSC", "Roadmap"].includes(bucket.key),
        );

        // Add the new "NIH Common Fund" object only if it doesn't already exist
        const hasCommonFund = nihObject.child.buckets.some(
          (bucket) => bucket.key === "NIH Common Fund",
        );

        if (!hasCommonFund) {
          nihObject.child.buckets.push({
            key: "NIH Common Fund",
            doc_count: 1,
          });
        }
      }
      // common fund manual inject

      let funding_orgs = [];
      org_list.forEach((parent, pindex) => {
        let temp_pindex = pindex;
        if (parent.key === "NIH") {
          temp_pindex = 0;
        } else {
          temp_pindex = pindex + 1;
        }

        funding_orgs.push({
          value: temp_pindex + "-a-" + parent.key,
          label: `<div class="d-flex">
          <div>
            ${parent.key}
          </div>
          <div class="ms-1 me-1">
          -
          </div>
          <div>
            ${fullName(parent.key)}
          </div>
        </div>`,
          abv: parent.key,
        });

        parent.child.buckets.forEach((child) => {
          if (
            child.key !== "AHRQ" &&
            child.key !== "NASA" &&
            child.key !== "HRSA" &&
            child.key !== "FDA" &&
            child.key !== "SAMHSA" &&
            child.key !== "Roadmap"
          ) {
            if (child.key === "NIH") {
              funding_orgs.push({
                value: temp_pindex + "-b-" + child.key,
                label: child.key + "-wide",
                isTabbed: true,
                abv: child.key + "-wide",
              });
            } else {
              funding_orgs.push({
                value: temp_pindex + "-b-" + child.key,
                label: `<div class="d-flex">
                        <div>
                          ${child.key}
                        </div>
                        <div class="ms-1 me-1">
                        ${fullName(child.key) && fullName(child.key) !== "" ? "-" : ""}
                        </div>
                        <div>
                          ${fullName(child.key)}
                        </div>
                      </div>`,
                isTabbed: true,
                abv: child.key,
              });
            }
          }
        });
      });

      funding_orgs.sort((a, b) =>
        a.value.localeCompare(b.value, "en", { sensitivity: "base" }),
      );

      // parent and primary ic preselected from the url
      let params_selected_orgs = [];
      if (queryParams.orgs && queryParams.orgs !== "all") {
        let i_pics = queryParams.orgs.toUpperCase();
        i_pics = i_pics.replace("NIH", "NIH-wide");
        i_pics = i_pics.replace("NIH-wide COMMON FUND", "NIH Common Fund");
        i_pics = i_pics.replace("NIH COMMON FUND", "NIH Common Fund");
        i_pics = i_pics.split(",");
        i_pics.forEach((ic) => {
          let f_primaryic = funding_orgs.find(
            (item) => item.abv === ic && item.isTabbed,
          );
          if (f_primaryic) {
            params_selected_orgs.push(f_primaryic);
          }
        });
      }
      if (queryParams.parent_orgs && queryParams.parent_orgs !== "all") {
        let i_rics = queryParams.parent_orgs.toUpperCase();
        i_rics = i_rics.split(",");
        i_rics.forEach((ic) => {
          let f_parentic = funding_orgs.find(
            (item) => item.abv === ic && item.isTabbed === undefined,
          );
          if (f_parentic) {
            params_selected_orgs.push(f_parentic);
          }
        });
      }
      if (params_selected_orgs.length > 0) {
        setFundingOrganizations(params_selected_orgs);
      }

      setFundingOrgs(funding_orgs);
    }

    // eslint-disable-next-line
  }, [state.default_orgs, orgsNames]);

  useEffect(() => {
    // if (expiredFOA || noResult) {
    if (state.default_acs && state.default_acs.buckets) {
      let activity_codes = [];
      let activity_codes_raw = state.default_acs.buckets;
      activity_codes_raw.forEach((ac) => {
        if (
          [
            "Kseries",
            "P20R24",
            "R4142",
            "R43R44",
            "R01(Collab)",
            "R34(Collab)",
            "U01R01",
            "UG3UH3",
          ].indexOf(ac.key) === -1
        ) {
          activity_codes.push({
            value: ac.key,
            label: ac.key,
          });
        }
      });

      activity_codes.sort((a, b) =>
        a.value.localeCompare(b.value, "en", { sensitivity: "base" }),
      );
      setActivityCode(activity_codes);
    }
    // } else {
    //   let activity_codes = [];
    //   if (state.aggs.data && state.aggs.data.aggregations) {
    //     let activity_codes_raw = state.aggs.data.aggregations.ac.buckets;
    //     activity_codes_raw.forEach((ac) => {
    //       activity_codes.push({
    //         value: ac.key,
    //         label: ac.key,
    //       });
    //     });
    //   }

    //   activity_codes.sort((a, b) =>
    //     a.value.localeCompare(b.value, "en", { sensitivity: "base" })
    //   );
    //     setActivityCode(activity_codes);
    // }
  }, [state.default_acs, state.aggs.data, expiredFOA, noResult]);

  useEffect(() => {
    if (debouncedInputValue) {
      recordAction("Query", debouncedInputValue.trim());
      if (debouncedInputValue.trim() !== "") {
        let updateDataQuery = {
          query: encodeURIComponent(debouncedInputValue.trim()),
        };
        console.log(queryParams.sort);
        if (queryParams && queryParams.sort && queryParams.sort !== "") {
          updateDataQuery.sort = queryParams.sort;
        } else {
          updateDataQuery.sort = "_score";
        }
        fetchData(updateDataQuery);
      }
    } else {
      if (state.result.data) {
        let temp_type = "";
        if (tabType === "foa") {
          temp_type = "active,activenosis";
        } else {
          temp_type = "notices,activenosis";
        }
        let updateDataQuery = {
          query: "",
          sort: "reldate:desc",
          type: temp_type,
        };
        fetchData(updateDataQuery);
      }
    }

    // eslint-disable-next-line
  }, [debouncedInputValue]);

  useEffect(() => {
    const mediaQuery = window.matchMedia("(max-width: 600px)");

    const handleMediaQueryChange = (e) => {
      setIsSmallScreen(e.matches);
    };
    handleMediaQueryChange(mediaQuery);
    mediaQuery.addEventListener("change", handleMediaQueryChange);
    return () => {
      mediaQuery.removeEventListener("change", handleMediaQueryChange);
    };
  }, []);

  const customStyles = {
    option: (provided, state) => ({
      ...provided,
      paddingLeft: state.data.isTabbed ? "30px" : "10px",
    }),
  };

  const handleQueryChange = (event) => {
    setQuery(event.target.value);
  };

  const handleDefaultActivityCode = (property) => {
    guide.SetCustomAC(dispatch, {
      [property]: "all",
    });
    if (state.custom_ac.activity_code === "") {
      fetchData({
        activitycodes: "all",
      });
    } else {
      fetchData({
        activitycodes: state.custom_ac.activity_code,
      });
    }
  };

  const handleFundingOrgs = (selectedOption) => {
    let tempFundingOrgs = [];
    selectedOption.forEach((item) => {
      tempFundingOrgs.push(item.abv);
    });
    recordAction("Funding Organization", tempFundingOrgs.join(","));
    setFundingOrganizations(selectedOption);
    let updateDataQuery = handleFundingOrgsHelper(selectedOption);
    if (updateDataQuery) {
      fetchData(updateDataQuery);
    } else {
      fetchData({
        primaryic: "all",
        parentic: "all",
      });
    }
  };

  const handleIssuingOrgs = (event) => {
    recordAction("Issuing Organization Only", event.target.checked);
    setIssuingOrgSelected(event.target.checked);
    let updateDataQuery = {
      spons: true,
    };
    if (event.target.checked) {
      updateDataQuery.spons = false;
    }
    fetchData(updateDataQuery);
  };

  const handleTitleSearch = (event) => {
    setTitleSelected(event.target.checked);
    recordAction("Title Only", event.target.checked);
    let updateDataQuery = {
      fields: "all",
    };
    if (event.target.checked) {
      updateDataQuery.fields = "title";
    }
    fetchData(updateDataQuery);
  };

  const handleAppType = (selectedOption) => {
    recordAction("Application Types Allowed", selectedOption);
    setAppTypesSelected(selectedOption);
    let updateDataQuery = handleAppTypeHelper(selectedOption);
    fetchData(updateDataQuery);
  };

  const handleResearchInitiative = (selectedOption) => {
    recordAction("Research Initiative", selectedOption);
    setResearchInitiativeSelected(selectedOption);
    let updateDataQuery = handleResearchInitiativeHelper(selectedOption);
    fetchData(updateDataQuery);
  };


  const handleActivityCode = (selectedOption) => {
    recordAction("Activity Code", selectedOption);
    setActivityCodesSelected(selectedOption);
    let updateDataQuery = handleActivityCodeHelper(selectedOption);
    handleFormattedAc("activity_code", updateDataQuery);
  };

  const handleInstrument = async (selectedOption) => {
    recordAction("Funding Instrument", selectedOption);
    setfundingInstrumentSelected(selectedOption);
    let updateDataQuery = await handleInstrumentHelper(selectedOption);
    handleFormattedAc("funding_instrument", updateDataQuery);
  };

  const handleFundingCategory = async (selectedOption) => {
    let check_subcategory_rtcd = false;
    let check_subcategory_rd = false;
    let check_subcategory_sb = false;

    selectedOption.forEach((item) => {
      if (item.value === "Research Training and Career Development") {
        check_subcategory_rtcd = true;
      }
      if (item.value === "Research and Development") {
        check_subcategory_rd = true;
      }
      if (item.value === "Small Business") {
        check_subcategory_sb = true;
      }
    });

    setFundingSubRTCDShow(check_subcategory_rtcd);
    setFundingSubRDShow(check_subcategory_rd);
    setFundingSubSBShow(check_subcategory_sb);

    setFundingCategory(selectedOption);
    let updateDataQuery = await handleFundingCategoryHelper(selectedOption);
    handleFormattedAc("funding_category", updateDataQuery);

    recordAction("Funding Category", selectedOption);
  };

  const handleFundingSubCategory_RTCD = async (selectedOption) => {
    setFundingSubCategory_RTCD(selectedOption);
    let updateDataQuery = handleFundingSubCategory_Helper(
      state.funding_sub_category,
      selectedOption,
      "Research Training and Career Development",
    );
    recordAction(
      "Funding Subcategory : Research Training and Career Development",
      selectedOption,
    );
    handleFormattedAc("funding_sub_category_rtcd", updateDataQuery);
  };

  const handleFundingSubCategory_RD = async (selectedOption) => {
    setFundingSubCategory_RD(selectedOption);
    recordAction(
      "Funding Subcategory : Research and Development",
      selectedOption,
    );
    let updateDataQuery = handleFundingSubCategory_Helper(
      state.funding_sub_category,
      selectedOption,
      "Research and Development",
    );
    handleFormattedAc("funding_sub_category_rd", updateDataQuery);
  };

  const handleFundingSubCategory_SB = async (selectedOption) => {
    setFundingSubCategory_SB(selectedOption);
    recordAction("Funding Subcategory : Small Business", selectedOption);
    let updateDataQuery = handleFundingSubCategory_Helper(
      state.funding_sub_category,
      selectedOption,
      "Small Business",
    );
    handleFormattedAc("funding_sub_category_sb", updateDataQuery);
  };

  const handleMentored = async (event) => {
    setMentoredSelected(event.target.value);
    recordAction("Mentored", event.target.value);
    let mentored = [];
    mentored.push(event.target.value);
    let updateDataQuery = await handleMentoredHelper(mentored);
    handleFormattedAc("mentored", updateDataQuery);
  };

  const handleReferenceLetters = async (event) => {
    setRefLetterSelected(event.target.value);
    recordAction("Reference Letters", event.target.value);
    let reference = [];
    reference.push(event.target.value);
    let updateDataQuery = await handleReferenceLettersHelper(reference);
    handleFormattedAc("reference_letters", updateDataQuery);
  };

  const handlePDPI = async (event) => {
    let pd_pi = [];
    pd_pi.push(event.target.value);
    setpdpiSelected(event.target.value);
    recordAction("PD/PI Citizenship Requirements", event.target.value);
    let updateDataQuery = await handlePDPIHelper(pd_pi);
    handleFormattedAc("pdpi_citizens", updateDataQuery);
  };

  const handleFormattedAc = (property, updateDataQuery) => {
    if (updateDataQuery) {
      const custom_properties = [
        "activity_code",
        "funding_instrument",
        "funding_category",
        "funding_sub_category_rtcd",
        "funding_sub_category_rd",
        "funding_sub_category_sb",
        "pdpi_citizens",
        "career_stage",
        "mentored",
        "reference_letters",
      ];
      const default_properties = custom_properties.filter(
        (item) => item !== property,
      );
      let prepared_string = [
        updateDataQuery.activitycodes.split("/").join(","),
      ];

      default_properties.forEach((item) => {
        let temp_custom_ac = state.custom_ac[item];
        if (Array.isArray(temp_custom_ac)) {
          temp_custom_ac = temp_custom_ac.join(",");
        }
        prepared_string.push(temp_custom_ac.split("/").join(","));
      });

      guide.SetCustomAC(dispatch, {
        [property]: updateDataQuery.activitycodes,
      });

      let formatted_ac = commonAC(prepared_string);

      if (formatted_ac && formatted_ac.trim() !== "") {
        setNoResult(false);
        fetchData({
          activitycodes: formatted_ac,
        });
      } else {
        setNoResult(true);
      }
    } else {
      if (property === "funding_category" && !updateDataQuery) {
        setFundingSubCategory_RTCD([]);
        setFundingSubCategory_RD([]);
        setFundingSubCategory_SB([]);
        guide.SetCustomAC(dispatch, {
          funding_sub_category_rtcd: "all",
          funding_sub_category_rd: "all",
          funding_sub_category_sb: "all",
        });
        handleDefaultActivityCode(property);
      } else if (
        (property === "funding_sub_category_rtcd" ||
          property === "funding_sub_category_rd" ||
          property === "funding_sub_category_sb") &&
        !updateDataQuery
      ) {
        if (state.custom_ac.funding_category !== "") {
          fetchData({
            activitycodes: state.custom_ac.funding_category,
          });
        }
        guide.SetCustomAC(dispatch, {
          funding_sub_category_rtcd: "all",
          funding_sub_category_rd: "all",
          funding_sub_category_sb: "all",
        });
      } else {
        handleDefaultActivityCode(property);
      }
    }
  };

  const handleCareerStage = async (selectedOption) => {
    setCareerStageSelected(selectedOption);
    recordAction("Career Stage", selectedOption);
    let updateDataQuery = await handleCareerStageHelper(selectedOption);
    handleFormattedAc("career_stage", updateDataQuery);
  };

  const handleClinicalTrials = (event) => {
    let value = "";
    let allowed_values = [];
    if (event.target.name === "clinical_trials_allowed") {
      if (event.target.value === "allowed") {
        value = "Optional,Required,Required_Infrastructure,Basic_Trial";
        setClinicalTrialOptions(true);
        setClinicalTrialsAllowedSelected("allowed");
        setClinicalTrialsSelected([
          "Optional",
          "Required,Required_Infrastructure",
          "Basic_Trial",
        ]);
        setClinicalTrialAllowOptions(["optional", "required", "besh"]);
        recordAction("Clinical Trials Allowed", "Yes");
      } else {
        setClinicalTrialOptions(false);
        if (event.target.value === "not_allowed") {
          value = "not_allowed";
          setClinicalTrialsAllowedSelected("not_allowed");
          setClinicalTrialsSelected("");
          setClinicalTrialAllowOptions([]);
          recordAction("Clinical Trials Not Allowed", "Yes");
        }
      }
    }

    if (event.target.name === "clinical_trial_allowed_options") {
      let temp_options = [...clinicalTrialAllowOptions];
      if (event.target.checked) {
        if (!temp_options.includes(event.target.value)) {
          temp_options.push(event.target.value);
        }
        setClinicalTrialAllowOptions(temp_options);
      } else {
        if (temp_options.includes(event.target.value)) {
          temp_options = temp_options.filter(
            (word) => word !== event.target.value,
          );
          setClinicalTrialAllowOptions(temp_options);
        }
      }
      allowed_values = clinicalTrialAllowedOptions(temp_options);

      if (allowed_values.length > 0) {
        value = allowed_values.join(",");
      } else {
        value = "Optional,Required,Required_Infrastructure,Basic_Trial";
      }
      setClinicalTrialsSelected(allowed_values);
    }
    let updateDataQuery = {
      clinicaltrials: value.length > 0 ? value : "all",
    };
    recordAction("Clinical Trials Allowed Options", value);
    fetchData(updateDataQuery);
  };

  const handleFundingOpportunityType = (selectedOption) => {
    recordAction("Funding Opportunity Type", selectedOption);
    let doctype = [];
    let parentfoa = "all";
    selectedOption.forEach((item) => {
      if (item.value !== "parentfoa") {
        doctype.push(item.value);
      } else {
        parentfoa = "yes";
      }
    });
    if (doctype.length > 0) {
      doctype = doctype.join(",");
    } else {
      doctype = "all";
    }
    let updateDataQuery = {
      parentfoa: parentfoa,
      doctype: doctype,
    };
    if (doctype.includes("NOSIS")) {
      setNosisCheckbox(true);
      if (!state.data_query.type.includes("nosis")) {
        let temp_type = "";
        if (state.data_query.type === "active") {
          temp_type = "active,activenosis";
        }
        if (state.data_query.type === "expired") {
          temp_type = "expired,expirednosis";
        }
        if (state.data_query.type === "active,expired") {
          temp_type = "active,expired,activenosis,expirednosis";
        }
        updateDataQuery.type = temp_type;
      }
    }
    setfundingOpportunitySelected(selectedOption);
    fetchData(updateDataQuery);
  };

  const handleNoticeType = (selectedOption) => {
    recordAction("Notice Type", selectedOption);
    setNoticeType(selectedOption);
    let noticeSubject_f = [];
    selectedOption.forEach((item) => {
      noticeSubject_f.push(item.value);
    });
    let noticeSubject_T = "all";
    if (noticeSubject_f.length > 0) {
      noticeSubject_T = noticeSubject_f.join(",");
    }

    let foaType = [...type];
    if (noticeSubject_T.includes("Notice of Special Interest")) {
      if (activeNotices) {
        if (!foaType.includes("activenosis")) {
          foaType.push("activenosis");
        }
      }
    }

    let updateDataQuery = {
      noticeSubject: noticeSubject_T,
      type: foaType.join(","),
    };

    fetchData(updateDataQuery);
  };

  let fetchData = (filters) => {
    if (!filters.hasOwnProperty("from")) {
      filters.from = 0;
    }
    let updateDataQuery = updateDataQueryHelper(state, filters);
    if (session.id !== "") {
      recordAction("Fetch Data", analyticsUrl(updateDataQuery));
    }

    guide.SetFilters(dispatch, updateDataQuery);
    guide.Result(dispatch, updateDataQuery);
  };

  let fetchAggs = (filters) => {
    let updateDataQuery = updateDataQueryHelper(state, filters);
    guide.Aggs(dispatch, updateDataQuery);
  };

  const changeView = (view) => {
    recordAction("View", view);
    setDataView(view);
  };

  const handleTypeChange = (event) => {
    let foaType = [...type];
    setItemOffset(0);
    const updateFOAState = (condition, stateSetter, foaValues) => {
      foaValues.forEach((foaValue) => {
        let index = foaType.indexOf(foaValue);
        if (condition && index === -1) {
          foaType.push(foaValue);
        } else if (!condition && index !== -1 && foaType.length > 1) {
          foaType.splice(index, 1);
        }
        stateSetter(condition);
      });
    };
    let temp_types = [];
    switch (event.target.name) {
      case "activeFOA":
        recordAction("Active Opportunities", event.target.checked);
        if (nosisCheckbox) {
          temp_types = ["active", "activenosis"];
        } else {
          temp_types = ["active"];
        }
        if (!event.target.checked) {
          if (expiredFOA) {
            updateFOAState(event.target.checked, setActiveFOA, temp_types);
          }
        } else {
          updateFOAState(event.target.checked, setActiveFOA, temp_types);
        }
        break;

      case "expiredFOA":
        recordAction("Expired Opportunities", event.target.checked);
        if (nosisCheckbox) {
          temp_types = ["expired", "expirednosis"];
        } else {
          temp_types = ["expired"];
        }
        if (!event.target.checked) {
          if (activeFOA) {
            updateFOAState(event.target.checked, setExpiredFOA, temp_types);
          }
        } else {
          updateFOAState(event.target.checked, setExpiredFOA, temp_types);
        }
        break;
      case "activeNotices":
        recordAction("Active Notices", event.target.checked);
        if (nosisCheckbox) {
          temp_types = ["notices", "activenosis"];
        } else {
          temp_types = ["notices"];
        }
        if (!event.target.checked) {
          if (expiredNotices) {
            updateFOAState(event.target.checked, setActiveNotices, temp_types);
          }
          setNosisCheckbox(true);
        } else {
          updateFOAState(event.target.checked, setActiveNotices, temp_types);
        }
        break;
      case "expiredNotices":
        recordAction("Expired Notices", event.target.checked);
        if (!event.target.checked) {
          if (activeNotices) {
            updateFOAState(event.target.checked, setExpiredNotices, [
              "expirednosis",
            ]);
          }
        } else {
          updateFOAState(event.target.checked, setExpiredNotices, [
            "expirednosis",
          ]);
        }
        break;
      case "nosisCheck":
        recordAction("Include NOSIs", event.target.checked);
        setNosisCheckbox(event.target.checked);
        if (event.target.checked) {
          if (tabType === "foa") {
            if (activeFOA) {
              if (!foaType.includes("activenosis")) {
                foaType.push("activenosis");
              }
            }
            if (expiredFOA) {
              if (!foaType.includes("expirednosis")) {
                foaType.push("expirednosis");
              }
            }
          }
          if (tabType === "notices") {
            if (activeNotices) {
              if (!foaType.includes("activenosis")) {
                foaType.push("activenosis");
              }
            }
          }
        } else {
          if (activeFOA || activeNotices) {
            foaType = foaType.filter((item) => item !== "activenosis");
          }
          if (expiredFOA) {
            foaType = foaType.filter((item) => item !== "expirednosis");
          }

          if (tabType === "notices" && !activeNotices) {
            setNosisCheckbox(true);
          }
        }
        break;
      default:
        break;
    }
    setType(foaType);

    let updateDataQuery = {
      type: foaType.join(","),
    };

    fetchData(updateDataQuery);
  };

  const handleTabTypeChange = (foa_type) => {
    setItemOffset(0);
    setFundingCategory([]);
    setFundingSubCategory_RTCD([]);
    setFundingSubRTCDShow(false);
    setFundingSubCategory_RD([]);
    setFundingSubRDShow(false);
    setFundingSubCategory_SB([]);
    setFundingSubSBShow(false);
    setActivityCodesSelected([]);
    setClinicalTrialsSelected("");
    setClinicalTrialsAllowedSelected("");
    setfundingOpportunitySelected("");
    setpdpiSelected("");
    setMentoredSelected("");
    setRefLetterSelected("");
    setfundingInstrumentSelected("");
    setAppTypesSelected("");
    setCareerStageSelected("");
    setNoticeType([]);

    let temp_foa = [];
    setTabType(foa_type);

    if (foa_type === "foa") {
      setNosisCheckbox(false);
      recordAction("Funding Opportunities Tab", "Selected");
      if (activeFOA) {
        temp_foa.push("active");
      }
      if (expiredFOA) {
        temp_foa.push("expired");
      }
      if (!activeFOA && !expiredFOA) {
        setActiveFOA(true);
        temp_foa.push("active");
      }
      setType(temp_foa);
      setNoticeType([]);
    }

    if (foa_type === "notices") {
      setNosisCheckbox(true);
      recordAction("Notices Tab", "Selected");
      if (activeNotices) {
        temp_foa.push("notices");
        temp_foa.push("activenosis");
      }
      if (expiredNotices) {
        temp_foa.push("expirednosis");
      }
      if (!activeNotices && !expiredNotices) {
        setActiveNotices(true);
        temp_foa.push("notices");
        temp_foa.push("activenosis");
      }
      setType(temp_foa);
      changeView("table");
    }

    let updateDataQuery = {
      type: temp_foa.join(","),
      noticeSubject: "all",
      activitycodes: "all",
      doctype: "all",
      parentfoa: "all",
      clinicaltrials: "all",
      apptype: "all",
    };

    guide.ClearCustomAC(dispatch);

    fetchData(updateDataQuery);
    fetchAggs(updateDataQuery);
  };

  const fullName = (ic) => {
    let result = orgsNames.find((org) => org.abv === ic);
    if (result) {
      return result.name;
    } else {
      return "";
    }
  };

  const handlePageClick = (event) => {
    const newOffset = (event.selected * itemsPerPage) % state.total_result;

    recordAction("Page", event.selected);

    setItemOffset(event.selected);
    let updateDataQuery = {
      from: newOffset,
    };

    fetchData(updateDataQuery);
  };

  const generateUrl = () => {
    let url = `${window.location.origin}${
      window.location.pathname
    }?query=${encodeURIComponent(state.data_query.query)}&type=${
      state.data_query.type
    }&foa=${state.data_query.doctype}&parent_orgs=${
      state.data_query.parentic
    }&orgs=${state.data_query.primaryic}&ac=${
      state.data_query.activitycodes
    }&ct=${state.data_query.clinicaltrials}&pfoa=${
      state.data_query.parentfoa
    }&date=${state.data_query.daterange}&fields=${
      state.data_query.fields
    }&spons=${state.data_query.spons}&noticeSubject=${
      state.data_query.noticeSubject
    }&researchInitiative=${state.data_query.researchInitiative}`
    ;
    return url;
  };

  const analyticsUrl = (req) => {
    if (req) {
      let url = `${window.location.origin}${window.location.pathname}?query=${req.query}&type=${req.type}&foa=${req.doctype}&parent_orgs=${req.parentic}&orgs=${req.primaryic}&ac=${req.activitycodes}&ct=${req.clinicaltrials}&pfoa=all&date=${req.daterange}&fields=${req.fields}&spons=${req.spons}&noticeSubject=${req.noticeSubject}`;
      return url;
    }
    return "Unable to create URL";
  };

  const clearFilters = () => {
    setItemOffset(0);
    recordAction("Clear Filters", "Cleared");
    setNoResult(false);
    setFundingCategory([]);
    setFundingSubCategory_RTCD([]);
    setFundingSubRTCDShow(false);
    setFundingSubCategory_RD([]);
    setFundingSubRDShow(false);
    setFundingSubCategory_SB([]);
    setFundingSubSBShow(false);

    setFundingOrganizations([]);

    setQuery("");
    setActivityCodesSelected([]);
    setClinicalTrialsSelected("");
    setClinicalTrialsAllowedSelected("");
    setStartDate(new Date(1991, 0, 1));
    setEndDate(new Date());
    setfundingOpportunitySelected("");
    setpdpiSelected("");
    setMentoredSelected("");
    setRefLetterSelected("");
    setfundingInstrumentSelected("");
    setIssuingOrgSelected(false);
    setAppTypesSelected("");
    setResearchInitiativeSelected("");
    setCareerStageSelected("");
    setNoticeType([]);
    setTitleSelected(false);
    setAlert(false);

    let temp_foa = ["notices"];

    if (tabType === "foa") {
      temp_foa = ["active"];
      setActiveFOA(true);
      setExpiredFOA(false);
      setActiveNotices(true);
      setExpiredNotices(false);
      setNosisCheckbox(false);
    } else {
      temp_foa = ["notices", "activenosis"];
      setActiveFOA(true);
      setExpiredFOA(false);
      setActiveNotices(true);
      setExpiredNotices(false);
      setNosisCheckbox(true);
    }

    setType(temp_foa);

    guide.ClearFilters(dispatch);
    guide.Result(dispatch, {
      perpage: 20,
      sort: "reldate:desc",
      from: 0,
      type: "notices,activenosis",
      parentic: "all",
      primaryic: "all",
      activitycodes: "all",
      doctype: "all",
      parentfoa: "all",
      daterange: "01011991-" + formatDate(new Date()),
      clinicaltrials: "all",
      fields: "all",
      apptype: "all",
      noticeSubject: "all",
      researchInitiative: "all",
      spons: true,
      query: "",
    });
    removeQueryParams();
    // handleClose();
  };

  const handleShowSaveResult = (show) => {
    setLinkCopied("");
    setShowShareResults(show);
  };

  const handleCopyToClipboard = () => {
    recordAction("Share Search", "Copied");
    navigator.clipboard
      .writeText(generateUrl())
      .then(() => {
        setLinkCopied("Copied!");
      })
      .catch((err) => {
        setLinkCopied("Unable to copy.");
      });
  };

  const handleSaveSearch = (event) => {
    if (event.target.id === "saved_search_name") {
      let temp = { ...saveResult };
      temp.subscription = event.target.value;
      setSaveResult(temp);
    }
    if (event.target.id === "saved_search_email") {
      let temp = { ...saveResult };
      temp.email = event.target.value;
      setSaveResult(temp);
    }
    if (event.target.id === "saved_search_frequency") {
      let temp = { ...saveResult };
      temp.frequency = event.target.value;
      setSaveResult(temp);
    }
  };

  const handleSaveResult = () => {
    setSaveResult({
      subscription: "",
      frequency: "daily",
      email: "",
    });
    setSaveResults(true);
  };

  const hideSubmitSearch = () => {
    setSaveResults(false);
    setEmailAlert(false);
    setSaveResult({
      subscription: "",
      frequency: "daily",
      email: "",
    });
  };

  const submitSaveSearch = () => {
    let errors = false;
    if (saveResult.subscription === "" || saveResult.email === "") {
      setSaveResultError(true);
      errors = true;
    }
    if (!errors) {
      let primaryIC = state.data_query.primaryic;
      if (primaryIC.includes("NIH Common Fund")) {
        primaryIC = primaryIC.replace("NIH Common Fund", "OSC,RMOD,Roadmap");
      }
      let url = `https://search.grants.nih.gov/guide/api/email?perpage=${state.data_query.perpage}&sort=${state.data_query.sort}&from=${state.data_query.from}&type=${state.data_query.type}&parentic=${state.data_query.parentic}&primaryic=${primaryIC}&activitycodes=${state.data_query.activitycodes}&doctype=${state.data_query.doctype}&parentfoa=${state.data_query.parentfoa}&daterange=${state.data_query.daterange}&clinicaltrials=${state.data_query.clinicaltrials}&fields=${state.data_query.fields}&spons=${state.data_query.spons}&query=${state.data_query.query}&frequency=${saveResult.frequency}&user=${saveResult.email}&subscription=${saveResult.subscription}`;
      axios.post(url).then((res) => {
        if (res.data.status === 200) {
          setEmailAlert(true);
          recordAction("Email Subscription", "Subscribed");
        } else {
          setSaveResultError(true);
          recordAction("Email Subscription", "Failed");
        }
      });
    }
  };

  const exportResult = () => {
    setExportLoading(true);
    let primaryIC = state.data_query.primaryic;
    if (primaryIC.includes("NIH Common Fund")) {
      primaryIC = primaryIC.replace("NIH Common Fund", "OSC,RMOD,Roadmap");
    }
    let url = `${GuideAPI}/export_csv?perpage=10000&sort=${state.data_query.sort}&from=${state.data_query.from}&type=${state.data_query.type}&parentic=${state.data_query.parentic}&primaryic=${primaryIC}&activitycodes=${state.data_query.activitycodes}&doctype=${state.data_query.doctype}&parentfoa=${state.data_query.parentfoa}&daterange=${state.data_query.daterange}&clinicaltrials=${state.data_query.clinicaltrials}&fields=${state.data_query.fields}&spons=${state.data_query.spons}&query=${state.data_query.query}&category=${state.data_query.researchInitiative}`;
    axios.get(url).then((res) => {
      if (res.data) {
        var blob = new Blob([res.data], { type: "text/csv" });
        var link = document.createElement("a");
        link.href = window.URL.createObjectURL(blob);
        link.download = "NIH_Guide_Results.csv";
        document.body.appendChild(link);
        link.click();
        document.body.removeChild(link);
        recordAction("Export Result", "Downloaded");
        setExportLoading(false);
      } else {
        recordAction("Export Result", "Download Failed");
      }
    });
  };

  const setCookie = (name, value) => {
    document.cookie = name + "=" + (value || "") + "; path=/";
  };

  const getCookie = (name) => {
    const nameEQ = name + "=";
    const ca = document.cookie.split(";");
    for (let i = 0; i < ca.length; i++) {
      let c = ca[i].trim();
      if (c.indexOf(nameEQ) === 0) return c.substring(nameEQ.length, c.length);
    }
    return null;
  };

  const hideAlert = () => {
    setAlert(false);
    setCookie("grants_legacy_url_alert", "hide");
  };

  const CustomMultiValue = (props) => {
    return (
      <components.MultiValue {...props}>
        <span>{props.data.abv}</span>{" "}
      </components.MultiValue>
    );
  };

  const removeQueryParams = () => {
    const urlWithoutQuery = window.location.origin + window.location.pathname;
    window.history.replaceState({}, "", urlWithoutQuery);
  };

  const onStartChange = (date) => {
    if (isValid(date)) {
      setStartDate(date);
      let updateDataQuery = {
        daterange: `${formatDate(date)}-${formatDate(endDate)}`,
      };
      fetchData(updateDataQuery);
      fetchAggs(updateDataQuery);
    }
  };

  const onEndChange = (date) => {
    if (isValid(date)) {
      setEndDate(date);
      let updateDataQuery = {
        daterange: `${formatDate(startDate)}-${formatDate(date)}`,
      };
      fetchData(updateDataQuery);
      fetchAggs(updateDataQuery);
    }
  };

  const handlePredefinedRange = (type) => {
    let s_date = new Date();
    let e_date = new Date();
    switch (type) {
      case "today":
        s_date = new Date();
        e_date = new Date();
        break;
      case "thisWeek":
        s_date = startOfWeek(new Date());
        e_date = endOfWeek(new Date());
        break;
      case "thisMonth":
        s_date = startOfMonth(new Date());
        e_date = new Date();
        break;
      case "lastMonth":
        s_date = startOfMonth(addMonths(new Date(), -1));
        e_date = endOfMonth(addMonths(new Date(), -1));
        break;
      case "thisYear":
        s_date = new Date(new Date().getFullYear(), 0, 1);
        e_date = new Date();
        break;
      case "lastYear":
        s_date = new Date(new Date().getFullYear() - 1, 0, 1);
        e_date = new Date(new Date().getFullYear(), 0, 0);
        break;
      default:
        break;
    }
    setStartDate(s_date);
    setEndDate(e_date);
    let updateDataQuery = {
      daterange: `${formatDate(s_date)}-${formatDate(e_date)}`,
    };
    fetchData(updateDataQuery);
    fetchAggs(updateDataQuery);
  };

  return (
    <div className="guide-search-app-wrapper">
      <div className="container-fluid mt-4">
        <div className="bg-grey row">
          {isSmallScreen && (
            <div className="col-12 d-flex mb-4 justify-content-around">
              <div
                className={
                  (tabType === "foa" ? "deep-blue" : "shadowed-grey") +
                  "  px-5 py-2 text-white fw-bold rounded text-center me-3 cursor-pointer"
                }
                onClick={() => {
                  handleTabTypeChange("foa");
                }}
              >
                Funding <br />
                Opportunities
              </div>
              <div
                className={
                  (tabType === "notices" ? "deep-blue" : "shadowed-grey") +
                  " funding-button px-5 py-2 text-white fw-bold rounded text-center cursor-pointer"
                }
                onClick={() => {
                  handleTabTypeChange("notices");
                }}
              >
                Other <br />
                Notices
              </div>
            </div>
          )}
        </div>

        {!isSmallScreen && tabType === "notices" && (
          <div className="utilityBar">
            {!noResult &&
              state.result.data &&
              state.result.data.hits.hits &&
              state.result.data.hits.hits.length > 0 && (
                <div className="me-4 blue d-flex align-items-center">
                  <span className="me-1 utility-icons" onClick={exportResult}>
                    {exportLoading ? (
                      <div
                        data-ds-id="kyfz2v3x"
                        class="spinner-border text-primary"
                        role="status"
                        style={{ marginTop: "-12px" }}
                      >
                        <span class="visually-hidden">Downloading...</span>
                      </div>
                    ) : (
                      <>
                        <span>Export Results</span> <ExcelIcon />
                      </>
                    )}
                  </span>
                </div>
              )}
            {!noResult &&
              state.result.data &&
              state.result.data.hits.hits &&
              state.result.data.hits.hits.length > 0 && (
                <div className="me-4 blue d-flex align-items-center">
                  <span
                    className="me-1 utility-icons"
                    onClick={() => setShowShareResults(true)}
                  >
                    Share Results
                  </span>{" "}
                  <ShareIcon />
                </div>
              )}

            {!noResult &&
              state.result.data &&
              state.result.data.hits.hits &&
              state.result.data.hits.hits.length > 0 && (
                <div className="blue d-flex align-items-center">
                  <span
                    className="me-1 utility-icons"
                    onClick={handleSaveResult}
                  >
                    Save Results
                  </span>{" "}
                  <SaveIcon />
                </div>
              )}
          </div>
        )}

        <div className="row">
          {!isSmallScreen && (
            <div className="topTab d-flex">
              <div
                className={
                  (tabType === "foa" ? "bg-paste" : "bg-grey") +
                  " p-3 pe-5 ps-5 text-center fw-bold rounded-top me-3 cursor-pointer"
                }
                onClick={() => {
                  handleTabTypeChange("foa");
                }}
              >
                Funding Opportunities
              </div>
              <div
                className={
                  (tabType === "notices" ? "bg-paste" : "bg-grey") +
                  " p-3 text-center pe-5 ps-5 fw-bold rounded-top cursor-pointer"
                }
                onClick={() => {
                  handleTabTypeChange("notices");
                }}
              >
                Notices
              </div>
            </div>
          )}
        </div>

        {tabType === "foa" && (
          <div
            className={
              isSmallScreen ? "bg-grey px-3 py-4" : "bg-paste px-5 py-4"
            }
          >
            <div className="bg-white p-3 pb-2">
              <div
                class="alert alert-info border-0 border-start border-7 border-info d-flex"
                role="alert"
              >
                <i class="bi bi-info-circle-fill me-3 h4"></i>
                <div>
                  <strong>
                    As of October 2025, NIH no longer posts notices of funding
                    opportunities (NOFOs) in the NIH Guide for Grants and
                    Contracts. Grants.gov is the sole, official repository for
                    NIH NOFOs going forward.
                  </strong>
                  <br />
                  <p className="mt-2">
                    Since NOFOs will no longer be included in our weekly
                    subscription emails, we encourage you to take advantage of{" "}
                    <a href="https://www.grants.gov/connect/manage-subscriptions/">
                      Grants.gov subscription services
                    </a>{" "}
                    for notifications of new opportunities.
                    <br />
                    <a href="https://www.grants.gov/search-grants">
                      Grants.gov’s Search Grants
                    </a>
                  </p>
                  <p>
                    Due to the number and breadth of opportunities available
                    through NIH, we’ve provided additional search tools with
                    NIH-specific filters to help quickly identify potential
                    opportunities of interest with links to Grants.gov for the
                    official postings.
                    <br />
                    <a href="/funding/explore-nih-opportunities">
                      Explore NIH Opportunities
                    </a>
                  </p>
                </div>
              </div>
            </div>
          </div>
        )}

        {tabType === "notices" ? (
          <div
            className={
              isSmallScreen ? "bg-grey px-3 py-4" : "bg-paste px-5 py-4"
            }
          >
            <div className="d-flex flex-column flex-md-row">
              <label role="button" className="form-check me-3">
                <input
                  className="form-check-input"
                  type="checkbox"
                  name="activeNotices"
                  value="notices,activenosis"
                  checked={activeNotices}
                  onChange={handleTypeChange}
                />
                <span className="form-check-label">Active Notices</span>
              </label>
              <label role="button" className="form-check me-3">
                <input
                  className="form-check-input"
                  type="checkbox"
                  name="expiredNotices"
                  value="expirednosis"
                  checked={expiredNotices}
                  onChange={handleTypeChange}
                />
                <span className="form-check-label">Expired Notices</span>
              </label>
              <label role="button" className="form-check">
                <input
                  className="form-check-input"
                  type="checkbox"
                  name="nosisCheck"
                  checked={nosisCheckbox}
                  onChange={handleTypeChange}
                />
                <span className="form-check-label">
                  Include Notices of Special Interest (NOSIs)
                </span>
              </label>
            </div>
          </div>
        ) : (
          ""
        )}

        {tabType === "notices" ? (
          <div
            className={isSmallScreen ? "bg-grey p-3 py-1" : "bg-paste p-5 py-1"}
          >
            <div className="filters-wrapper">
              <div className="filters-card-wrapper">
                <div
                  className={
                    "shadow filter-card  f1 bg-white card-top-border border-4 border-top rounded-2 p-4 " +
                    (fundingSubRTCDShow || fundingSubRDShow || fundingSubSBShow
                      ? "extended"
                      : "")
                  }
                >
                  {tabType === "foa" && (
                    <div>
                      <h5>
                        Funding Category
                        <InformationToolTip
                          content={InformationToolTipOptions.fundingCategory}
                          placement={isSmallScreen ? "bottom" : "right"}
                        />
                      </h5>{" "}
                      <Select
                        options={state.fetched_options.funding_category}
                        isMulti
                        onChange={handleFundingCategory}
                        hideSelectedOptions={false}
                        value={fundingCategory}
                      />
                      <p className="mt-2">
                        <a href="/funding/funding-categories">
                          Learn more about Funding Categories
                        </a>
                      </p>
                    </div>
                  )}

                  {tabType === "notices" && (
                    <div>
                      <h5>
                        Notice Type
                        <InformationToolTip
                          content={InformationToolTipOptions.noticeType}
                          placement={isSmallScreen ? "bottom" : "right"}
                          trigger="click"
                        />
                      </h5>{" "}
                      <Select
                        options={noticeSubject}
                        isMulti
                        onChange={handleNoticeType}
                        hideSelectedOptions={false}
                        value={noticeType}
                        className="option-select"
                        classNamePrefix="react-select"
                      />
                      <div className="p-4"></div>
                    </div>
                  )}
                </div>
                <div className="shadow filter-card  f2 bg-white card-top-border border-4 border-top rounded-2 p-4">
                  <div>
                    <h5>
                      Funding Organization(s)
                      <InformationToolTip
                        content={InformationToolTipOptions.fundingOrgs}
                        placement={isSmallScreen ? "bottom" : "right"}
                      />
                    </h5>
                    <div className="mb-3">
                      <Select
                        options={fundingOrgs}
                        isMulti
                        styles={customStyles}
                        onChange={handleFundingOrgs}
                        hideSelectedOptions={false}
                        value={fundingOrganizations}
                        formatOptionLabel={(option) => (
                          <div>{Parser().parse(option.label)}</div>
                        )}
                        components={{ MultiValue: CustomMultiValue }}
                        className="option-select"
                        classNamePrefix="react-select"
                      />
                    </div>
                    <label role="button" className="form-check pb-4">
                      <input
                        className="form-check-input"
                        type="checkbox"
                        value=""
                        checked={issuingOrgSelected}
                        onChange={handleIssuingOrgs}
                      />
                      <span className="form-check-label">
                        Issuing Organization Only
                      </span>
                    </label>
                  </div>
                </div>
                <div className="shadow filter-card f3 bg-white card-top-border border-4 border-top rounded-2 p-4">
                  <div>
                    <h5>
                      Keyword
                      <InformationToolTip
                        content={InformationToolTipOptions.keyword}
                        placement="bottom"
                      />
                    </h5>
                    <label className="form-label d-block mb-3">
                      <div className="searchIcon">
                        <SearchIcon />
                      </div>
                      <input
                        type="text"
                        className="form-control mt-2 border-1"
                        id="searchQuery"
                        placeholder="Quick Search"
                        onChange={handleQueryChange}
                        value={query}
                      />
                    </label>
                    <label role="button" className="form-check pb-4">
                      <input
                        className="form-check-input"
                        type="checkbox"
                        value=""
                        checked={titleSelected}
                        onChange={handleTitleSearch}
                      />
                      <span className="form-check-label">Title Only</span>
                    </label>
                  </div>
                </div>
                {(fundingSubRTCDShow ||
                  fundingSubRDShow ||
                  fundingSubSBShow) && (
                  <div className="sub-filters f4 mt-0 p-3">
                    <SubCategoryFilters
                      fundingSubRTCDShow={fundingSubRTCDShow}
                      fundingSubRDShow={fundingSubRDShow}
                      fundingSubSBShow={fundingSubSBShow}
                      career_stage={career_stage}
                      handleCareerStage={handleCareerStage}
                      careerStageSelected={careerStageSelected}
                      handlePDPI={handlePDPI}
                      pdpiSelected={pdpiSelected}
                      subcategory_rtcd={
                        state.fetched_options.funding_sub_category.rtcd
                      }
                      handleFundingSubCategory_RTCD={
                        handleFundingSubCategory_RTCD
                      }
                      fundingSubCategory_RTCD={fundingSubCategory_RTCD}
                      subcategory_rd={
                        state.fetched_options.funding_sub_category.rd
                      }
                      handleFundingSubCategory_RD={handleFundingSubCategory_RD}
                      fundingSubCategory_RD={fundingSubCategory_RD}
                      subcategory_sb={
                        state.fetched_options.funding_sub_category.sb
                      }
                      handleFundingSubCategory_SB={handleFundingSubCategory_SB}
                      fundingSubCategory_SB={fundingSubCategory_SB}
                      isSmallScreen={isSmallScreen}
                      InformationToolTipOptions={InformationToolTipOptions}
                    />
                  </div>
                )}
              </div>

              <div className="row">
                <div className="mt-4">
                  <div className="col-12 d-flex align-items-center flex-column flex-md-row justify-content-between">
                    <div>
                      <span
                        className="advancedSearch mb-3"
                        onClick={handleShow}
                      >
                        <Filter /> Advanced Search
                      </span>
                    </div>
                    <div className="d-flex flex-column align-items-end pill-container">
                      <CurrentFiltersPills
                        background="bg-paste"
                        isSmallScreen={isSmallScreen}
                        fundingCategory={fundingCategory}
                        type={type}
                        tabType={tabType}
                        noticeType={noticeType}
                        activity_code={state.custom_ac.activity_code}
                        clinicalTrialsAllowedSelected={
                          clinicalTrialsAllowedSelected
                        }
                        fundingInstrumentSelected={fundingInstrumentSelected}
                        fundingOrganizations={fundingOrganizations}
                        issuingOrgSelected={issuingOrgSelected}
                        appTypesSelected={appTypesSelected}
                        careerStageSelected={careerStageSelected}
                        fundingOpportunitySelected={fundingOpportunitySelected}
                        query={query}
                        mentoredSelected={mentoredSelected}
                        pdpiSelected={pdpiSelected}
                        refLetterSelected={refLetterSelected}
                        fundingSubCategory_RTCD={fundingSubCategory_RTCD}
                        fundingSubCategory_RD={fundingSubCategory_RD}
                        fundingSubCategory_SB={fundingSubCategory_SB}
                        startDate={startDate}
                        endDate={endDate}
                        researchInitiativeSelected={researchInitiativeSelected}
                      />

                      <span
                        className="ms-4 clearFilters mb-3"
                        onClick={clearFilters}
                      >
                        Clear Filters
                      </span>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        ) : (
          ""
        )}

        {tabType === "notices" ? (
          <div
            className={
              isSmallScreen ? "bg-paste p-3 pt-1" : "bg-paste p-5 py-1"
            }
          >
            <div className="results-wrapper">
              <div className="row mt-2">
                <div className="col-lg-6 col-12 d-flex align-items-center mb-3">
                  {!noResult && (
                    <div className="me-4">
                      {state.total_result <= 20 ? (
                        state.total_result > 0 ? (
                          <>
                            <span className="fw-bold">Displaying: </span>
                            {state.total_result}
                          </>
                        ) : (
                          ""
                        )
                      ) : (
                        <>
                          <span className="fw-bold">Displaying: </span>{" "}
                          {state.data_query.from === 0
                            ? 1
                            : state.data_query.from + 1}
                          -
                          {state.data_query.from + 20 > state.total_result
                            ? state.total_result
                            : state.data_query.from + 20}{" "}
                          of {state.total_result.toLocaleString()}
                        </>
                      )}
                    </div>
                  )}
                </div>

                {/* {!noResult &&
                  !isSmallScreen &&
                  state.result.data &&
                  state.result.data.hits.hits &&
                  state.result.data.hits.hits.length > 0 && (
                    <div className="col-lg-6 col-12 d-flex justify-content-end">
                      <div
                        className="btn-group border-2  border-primary"
                        role="group"
                        aria-label="Basic radio toggle button group"
                      >
                        <input
                          type="radio"
                          className="btn-check"
                          name="btnradio"
                          id="btnradio1"
                          autoComplete="off"
                          defaultChecked
                          onClick={() => {
                            changeView("table");
                          }}
                        />
                        <label
                          className="btn btn-outline-secondary border-2 d-flex align-items-center"
                          htmlFor="btnradio1"
                        >
                          <TableIcon /> <span className="ms-2">Table View</span>
                        </label>

                        <input
                          type="radio"
                          className="btn-check"
                          name="btnradio"
                          id="btnradio2"
                          autoComplete="off"
                          onClick={() => {
                            changeView("detail");
                          }}
                        />
                        <label
                          className="btn btn-outline-secondary border-2 border-start-0"
                          htmlFor="btnradio2"
                        >
                          <ListIcon />{" "}
                          <span className="ms-2">Detailed View</span>
                        </label>
                      </div>
                    </div>
                  )} */}
              </div>
              {!noResult ? (
                isSmallScreen ? (
                  state.result.data &&
                  state.result.data.hits.hits &&
                  state.result.data.hits.hits.length > 0 && (
                    <MobileDataView
                      data={state.result.data.hits.hits}
                      fullName={fullName}
                      date_utc_options={date_utc_options}
                    />
                  )
                ) : dataView === "table" ? (
                  <div className="row mt-3">
                    <div className="col-12">
                      {state.result.data &&
                      state.result.data.hits.hits &&
                      state.result.data.hits.hits.length > 0 ? (
                        <TableDataView
                          data={state.result.data.hits.hits}
                          fetchData={fetchData}
                          tabType={tabType}
                          query={query}
                          InformationToolTipOptions={InformationToolTipOptions}
                          fullName={fullName}
                          recordAction={recordAction}
                          date_utc_options={date_utc_options}
                        />
                      ) : (
                        <NoResultView category={state.data_query} />
                      )}
                    </div>
                  </div>
                ) : (
                  <>
                    {state.funding_category.length > 0 &&
                    state.funding_instrument.length > 0 &&
                    state.pdpi_citizens.length > 0 &&
                    state.career_stage.length > 0 &&
                    state.mentored.length > 0 &&
                    state.activity_codes.length > 0 &&
                    state.result.data &&
                    state.result.data.hits.hits &&
                    state.result.data.hits.hits.length > 0 ? (
                      <DetailedDataView
                        data={state.result.data.hits.hits}
                        InformationToolTipOptions={InformationToolTipOptions}
                        fullName={fullName}
                        recordAction={recordAction}
                        date_utc_options={date_utc_options}
                      />
                    ) : (
                      <NoResultView category={state.data_query} />
                    )}
                  </>
                )
              ) : (
                <NoResultView category={state.data_query} />
              )}
            </div>

            {Math.ceil(pageCount) > 1 && !noResult && (
              <div className="pagination">
                <ReactPaginate
                  breakLabel={isSmallScreen ? "." : "..."}
                  nextLabel={isSmallScreen ? ">" : "Next >"}
                  onPageChange={handlePageClick}
                  pageRangeDisplayed={isSmallScreen ? 1 : 4}
                  marginPagesDisplayed={isSmallScreen ? 1 : 4}
                  pageCount={Math.ceil(pageCount)}
                  previousLabel={isSmallScreen ? "<" : "< Previous"}
                  renderOnZeroPageCount={null}
                  forcePage={itemOffset}
                />
              </div>
            )}
          </div>
        ) : (
          ""
        )}
      </div>

      <Modal
        show={show}
        onHide={handleClose}
        dialogClassName={isSmallScreen ? "" : "modal-90w"}
      >
        <Modal.Header closeButton>
          <Modal.Title>
            Advanced Search for{" "}
            {tabType === "foa" ? "Funding Opportunities" : "Notices"}
          </Modal.Title>
        </Modal.Header>
        <Modal.Body>
          <MoreFiltersView
            tabType={tabType}
            fundingCategoryOptions={state.fetched_options.funding_category}
            handleFundingCategory={handleFundingCategory}
            fundingCategorySelected={fundingCategory}
            issuingOrgSelected={issuingOrgSelected}
            handleIssuingOrgs={handleIssuingOrgs}
            activityCode={activityCode}
            activityCodesSelected={activityCodesSelected}
            fundingOrgs={fundingOrgs}
            handleFundingOrgs={handleFundingOrgs}
            fundingOrganizations={fundingOrganizations}
            clinicalTrialOptions={clinicalTrialOptions}
            clinicalTrialsSelected={clinicalTrialsSelected}
            clinicalTrialsAllowedSelected={clinicalTrialsAllowedSelected}
            handleActivityCode={handleActivityCode}
            handleClinicalTrials={handleClinicalTrials}
            handleInstrument={handleInstrument}
            fundingInstrumentSelected={fundingInstrumentSelected}
            fundingInstrumentOptions={state.fetched_options.funding_instrument}
            handleCareerStage={handleCareerStage}
            careerStageSelected={careerStageSelected}
            handleFundingOpportunityType={handleFundingOpportunityType}
            fundingOpportunitySelected={fundingOpportunitySelected}
            handlePDPI={handlePDPI}
            pdpiSelected={pdpiSelected}
            handleMentored={handleMentored}
            mentoredSelected={mentoredSelected}
            handleReferenceLetters={handleReferenceLetters}
            refLetterSelected={refLetterSelected}
            noticeTypeOptions={noticeSubject}
            handleNoticeType={handleNoticeType}
            noticeType={noticeType}
            handleAppType={handleAppType}
            appTypesSelected={appTypesSelected}
            handleQueryChange={handleQueryChange}
            subcategory_rtcd={state.fetched_options.funding_sub_category.rtcd}
            handleFundingSubCategory_RTCD={handleFundingSubCategory_RTCD}
            fundingSubCategory_RTCD={fundingSubCategory_RTCD}
            fundingSubRTCDShow={fundingSubRTCDShow}
            subcategory_rd={state.fetched_options.funding_sub_category.rd}
            handleFundingSubCategory_RD={handleFundingSubCategory_RD}
            fundingSubCategory_RD={fundingSubCategory_RD}
            fundingSubRDShow={fundingSubRDShow}
            subcategory_sb={state.fetched_options.funding_sub_category.sb}
            handleFundingSubCategory_SB={handleFundingSubCategory_SB}
            fundingSubCategory_SB={fundingSubCategory_SB}
            fundingSubSBShow={fundingSubSBShow}
            query={query}
            InformationToolTipOptions={InformationToolTipOptions}
            career_stage={career_stage}
            appTypesAllowed={appTypesAllowed}
            fundingOpportunityType={fundingOpportunityType}
            activeFOA={activeFOA}
            expiredFOA={expiredFOA}
            activeNotices={activeNotices}
            expiredNotices={expiredNotices}
            handleTypeChange={handleTypeChange}
            titleSelected={titleSelected}
            handleTitleSearch={handleTitleSearch}
            noticeSubject={noticeSubject}
            CustomMultiValue={CustomMultiValue}
            nosisCheckbox={nosisCheckbox}
            isSmallScreen={isSmallScreen}
            startDate={startDate}
            endDate={endDate}
            onStartChange={onStartChange}
            onEndChange={onEndChange}
            handlePredefinedRange={handlePredefinedRange}
            researchInitiative={researchInitiative}
            researchInitiativeSelected={researchInitiativeSelected}
            handleResearchInitiative={handleResearchInitiative}
          />
        </Modal.Body>
        <Modal.Footer>
          <div className="w-100 d-flex justify-content-between">
            <Button
              className="btn rounded-1 px-4 btn-primary"
              onClick={clearFilters}
            >
              Clear
            </Button>
            <Button
              className="btn rounded-1 px-4 btn-primary"
              onClick={handleClose}
            >
              Search
            </Button>
          </div>
        </Modal.Footer>
      </Modal>

      <Modal show={showShareResults} onHide={() => handleShowSaveResult(false)}>
        <Modal.Header closeButton>
          <Modal.Title>Share Search</Modal.Title>
        </Modal.Header>
        <Modal.Body>
          <div className="d-flex align-items-center">
            <div className="text-to-copy">
              <input
                type="text"
                className="form-control mt-2 border-1"
                id="shareSearch"
                placeholder="Quick Search"
                value={generateUrl()}
              />
            </div>
            <div
              className="guidesearch-icon ms-2"
              onClick={handleCopyToClipboard}
            >
              <CopyIcon />
            </div>
          </div>
          {linkCopied.trim() !== "" ? (
            linkCopied
          ) : (
            <div className="py-2">
              Click{" "}
              <span>
                <CopyIcon />
              </span>{" "}
              to copy
            </div>
          )}
        </Modal.Body>
        <Modal.Footer>
          <div className="w-100 d-flex justify-content-end">
            <Button
              className="btn rounded-1 px-4 btn-primary"
              onClick={() => handleShowSaveResult(false)}
            >
              Close
            </Button>
          </div>
        </Modal.Footer>
      </Modal>

      <Modal show={saveResults} onHide={hideSubmitSearch}>
        <Modal.Header closeButton>
          <Modal.Title>Save your search</Modal.Title>
        </Modal.Header>
        <Modal.Body>
          <p>
            Receive notifications any time new NIH Guide for Grants and
            Contracts entries match your search by providing your email below.
            We will notify you daily, weekly or monthly (your choice) of new
            entries that interest you.
          </p>
          <hr />
          <div className="">Current Search Criteria</div>
          <div className="mt-3">
            <CurrentFiltersPills
              background="bg-paste"
              isSmallScreen={isSmallScreen}
              fundingCategory={fundingCategory}
              type={type}
              tabType={tabType}
              noticeType={noticeType}
              activity_code={state.custom_ac.activity_code}
              clinicalTrialsAllowedSelected={clinicalTrialsAllowedSelected}
              fundingInstrumentSelected={fundingInstrumentSelected}
              fundingOrganizations={fundingOrganizations}
              issuingOrgSelected={issuingOrgSelected}
              appTypesSelected={appTypesSelected}
              careerStageSelected={careerStageSelected}
              fundingOpportunitySelected={fundingOpportunitySelected}
              query={query}
              mentoredSelected={mentoredSelected}
              pdpiSelected={pdpiSelected}
              refLetterSelected={refLetterSelected}
              fundingSubCategory_RTCD={fundingSubCategory_RTCD}
              fundingSubCategory_RD={fundingSubCategory_RD}
              fundingSubCategory_SB={fundingSubCategory_SB}
              startDate={startDate}
              endDate={endDate}
              researchInitiativeSelected={researchInitiativeSelected}
            />
          </div>
          <br />
          {saveResultError ? (
            <div
              data-ds-id="j2tmke3n"
              className="alert alert-danger border-0 border-start border-7 border-danger d-flex"
              role="alert"
            >
              <i className="bi bi-exclamation-circle-fill me-3 h4"></i>
              <div>
                <strong>Error</strong>
                <br />
                Please complete all fields to save results.
              </div>
            </div>
          ) : (
            ""
          )}

          {emailAlert ? (
            saveResultError ? (
              <div
                data-ds-id="j2tmke3n"
                className="alert alert-danger border-0 border-start border-7 border-danger d-flex"
                role="alert"
              >
                <i className="bi bi-exclamation-circle-fill me-3 h4"></i>
                <div>
                  <strong>Error</strong>
                  <br />
                  Unable to save subscription. Please try again.
                </div>
              </div>
            ) : (
              <div
                data-ds-id="j2tmke3n"
                class="alert alert-success border-0 border-start border-7 border-success d-flex"
                role="alert"
              >
                <i class="bi bi-check-circle-fill me-3 h4"></i>
                <div>
                  <strong>Success</strong>
                  <br />
                  Email subscription activated. A confirmation email has been
                  sent.
                </div>
              </div>
            )
          ) : (
            ""
          )}

          <label className="form-label d-block">
            <div>Saved Search Name:</div>
            <input
              type="text"
              className="form-control mt-2 border-1"
              id="saved_search_name"
              onChange={handleSaveSearch}
              required
            />
          </label>

          <label className="form-label d-block">
            <div>Email:</div>
            <input
              type="text"
              className="form-control mt-2 border-1"
              id="saved_search_email"
              onChange={handleSaveSearch}
            />
          </label>

          <div>Email Frequency:</div>
          <select
            className="form-select d-inline"
            aria-label="Default select example"
            id="saved_search_frequency"
            onChange={handleSaveSearch}
          >
            <option value="daily">Daily</option>
            <option value="weekly">Weekly</option>
            <option value="monthly">Monthly</option>
          </select>
        </Modal.Body>
        <Modal.Footer>
          <div className="w-100 d-flex justify-content-end">
            <Button
              className="btn rounded-1 px-4 btn-primary"
              onClick={hideSubmitSearch}
            >
              Close
            </Button>
            <Button
              className="btn rounded-1 px-4 btn-primary"
              onClick={submitSaveSearch}
            >
              Submit
            </Button>
          </div>
        </Modal.Footer>
      </Modal>
    </div>
  );
}

export default Main;
